import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import axios from 'axios';
import React, { useState, useEffect,Component  } from "react";
import { useNavigate } from 'react-router-dom';

const AWS = require('aws-sdk');

AWS.config.update({
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
});

const params = {
  TableName: "Main_table"
};


const apiUrl = "https://48zxiesfj2.execute-api.eu-west-2.amazonaws.com/default/modifyPersonLambda";

function Modify() {
  const [fname, setfname] = useState("");
  const [sname, setsname] = useState("");
  const [id, setID] = useState('');
  const [age, setage] = useState("");
  const [height, setheight] = useState("");
  const [ethnicity, setethnicity] = useState("");
  const [disability, setdisability] = useState(false);
  const [visitor, setvisitor] = useState(false);
  const [facecard, setfacecard] = useState(null);
  const [sex, setsex] = useState("");
  const [street, setstreet] = useState("");
  const [house_num, sethousenum] = useState("");
  const [post, setpost] = useState("");
  const [city, setcity] = useState("");
  const [phone, setphone] = useState("");
  const [emergencyName, setemergencyName] = useState("");
  const [emergencyNumber, setemergencyNumber] = useState("");
  const [facecardBase64, setFacecardBase64] = useState("");
  const [keepImage, setKeepImage] = useState("true");
  const [fetched_data, setData] = useState([]);
  const [filtered_data, setFiltered] = useState([]);
  const navigate = useNavigate();


  const HandleHome = (event) => {
    event.preventDefault();
    navigate('/adminpage'); 
  };
  const SearchPerson = (event) => {
    event.preventDefault();
    navigate('/searchPerson'); 
  };
  const HandleAddPerson = (event) => {
    event.preventDefault();
    navigate('/addPersonOption'); 
  };
  const StartEvac = (event) => {
    event.preventDefault();
    navigate('/start'); 
  };
  
  const RemovePerson = (event) => {
    event.preventDefault();
    navigate('/removePersonOption'); 
  };
  const ModifyPerson = (event) => {
    event.preventDefault();
    navigate('/modify'); 
  };
  const emergencyPlan = (event) => {
    event.preventDefault();
    navigate('/emergencyPlan'); 
  };


  const fetchData = async (event) => {
    event.preventDefault();
    const dynamoDB = new AWS.DynamoDB.DocumentClient();
    dynamoDB.scan(params, (err, result) => {
      if (err) {
        console.error('Error scanning the table',err);
      } else {
        console.log('Scan succeeded:', JSON.stringify(result, null, 2));
        const filtered = result.Items.filter(searchPerson);
        console.log(filtered);
        setData(filtered)
        setfname(filtered[0].fname);
        setsname(filtered[0].sname);
        setID(filtered[0].UserID);
        setage(filtered[0].age);
        setheight(filtered[0].height);
        setethnicity(filtered[0].ethnicity);
        setdisability(filtered[0].disability);
        setvisitor(filtered[0].visitor);
        setfacecard(filtered[0].facecard);
        setsex(filtered[0].sex);
        setstreet(filtered[0].street);
        sethousenum(filtered[0].house_num);
        setpost(filtered[0].post);
        setcity(filtered[0].city);
        setphone(filtered[0].phone);
        setemergencyName(filtered[0].emergencyName);
        setemergencyNumber(filtered[0].emergencyNumber);
      }
    });
  };

  function searchPerson(item) {
    return item.fname === fname || item.sname === sname;
  }


  const ChangeDetails = async (event) => {
    event.preventDefault();
    while (id == null){
      console.log("Person getting removed");
    }
    try {
      const userData = {
        id: id,
        type: "remove"
      };
      const response = await axios.post(apiUrl, userData);
      console.log('Data sent to API:', response.data);
      addPersontoDatabase();
      
    } catch (error) {
      console.error('Error sending data to API:', error);
      alert('Failed to add person!');
    }
  };

  const addPersontoDatabase = async () => {
    try {
      const userData = {
        id:id,
        fname: fname,
        sname: sname,
        age: age,
        height: height,
        ethnicity: ethnicity,
        sex: sex,
        disability: disability,
        visitor: visitor,
        city: city,
        house_num: house_num,
        post: post,
        street: street,
        phone: phone,
        emergencyName: emergencyName,
        emergencyNumber: emergencyNumber,
        facecard: facecardBase64, 
        keepImage: keepImage,
      };
      console.log(userData);
      const response = await axios.post(apiUrl, userData);
      console.log('Data sent to API:', response.data);
      navigate('/modifiedPerson');
    } catch (error) {
      console.error('Error sending data to API:', error);
      alert('Failed to add person!');
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setfacecard(file); 
    const reader = new FileReader();
    reader.onloadend = function () {
      setFacecardBase64(reader.result.split(',')[1]); 
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    setKeepImage("false");
  };

  return (
    <Container className= "main-page-content">
      <Row>
        <Col>
          <img className="app-logo" src={Logo} width="400" height="50" alt="SmartEvac Logo" />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <h3>Search Person to Modify</h3>
          <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="#home" onClick={HandleHome}>Home</Nav.Link>
                  <Nav.Link href="#link"onClick={SearchPerson} >Search</Nav.Link>
                  <Nav.Link href="#link" onClick={HandleAddPerson}>Add</Nav.Link>
                  <Nav.Link href="#link" onClick={RemovePerson}>Remove</Nav.Link>
                  <Nav.Link href="#link" onClick={ModifyPerson}>Modify</Nav.Link>
                  <Nav.Link href="#link" onClick={emergencyPlan}>Plan</Nav.Link>
                </Nav>
                <Nav className="ms-auto">
                  <Nav.Link href="#link" onClick={StartEvac}>Start Evacuation</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </Col>
      </Row>
      <br></br>
      <Row className="justify-content-center">
        <Col xs={7} sm={7} md={7} lg={7}>
          <form className="loginForm" onSubmit={fetchData}>
            <p className="Title">Find ID of Person to Modify</p>
            <Row>
              <Col xs={12} md={6}>
                <div className="form-group">
                  <input type="text" name="fname" placeholder="First name" onChange={(e) => setfname(e.target.value)} />
                </div>
                <div className="form-group">
                  <input type="text" name="sname" placeholder="Surname" onChange={(e) => setsname(e.target.value)} />
                </div>
              </Col>
              <button type="submit" className="login-button">Search</button>
            </Row>
            <br></br>
            <br></br>
            <Row>
              <h3>Original</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>age</th>
                    <th>sex</th>
                    <th>height</th>
                    <th>ethnicity</th>
                  </tr>
                </thead>
                <tbody>
                  {fetched_data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.UserID}</td>
                      <td>{item.fname}</td>
                      <td>{item.sname}</td>
                      <td>{item.age}</td>
                      <td>{item.sex}</td>
                      <td>{item.height}</td>
                      <td>{item.ethnicity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
          </form>
          <br></br>
          <br></br>
          <Row className="justify-content-center">
            <Col>
              <form className="loginForm">
                <p className="Title">Change Person details</p>
                <Row>
                  <Col xs={12} md={6}>
                    <div className="form-group">
                      <input type="text" name="fname" value={fname} onChange={(e) => setfname(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="text" name="sname" value={sname} onChange={(e) => setsname(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="date" name="age" value={age} onChange={(e) => setage(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="text" id="city" name="city" value={city} onChange={(e) => setsex(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="text" id="house_num" name="house_num" value={house_num} onChange={(e) => sethousenum(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="tel" id="phone" name="phone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" value={phone} onChange={(e) => setphone(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="text" id="emergency_contact" name="emergency_contact" value={emergencyName} onChange={(e) => setemergencyName(e.target.value)} />
                    </div>
                  </Col>

                
                  <Col xs={12} md={6}>
                    <div className="form-group">
                      <input type="number" id="height" name="height" value={height} onChange={(e) => setheight(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="text" id="ethnicity" name="ethnicity" value={ethnicity} onChange={(e) => setethnicity(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="text" id="sex" name="sex" value={sex} onChange={(e) => setsex(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="text" id="street" name="street" value={street} onChange={(e) => setstreet(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="text" id="postcode" name="postcode" value={post} onChange={(e) => setpost(e.target.value)} />
                    </div>
                    <div className="form-group">
                      <input type="tel" id="Emergphone" name="Emergphone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" value={emergencyNumber} onChange={(e) => setemergencyNumber(e.target.value)} />
                    </div>
                  </Col>
                </Row>
                <p>Upload a new facecard</p>
                <p>If no file is uploaded the original facecard will be used</p>
                <div className="form-group">
                  <input type="file" id="facecard" name="facecard" placeholder="Facecard" onChange={handleFileChange}/>
                </div>
                <button type="submit" className="login-button" onClick={ChangeDetails}>Change</button>
              </form>

            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Modify;
